import { Button } from 'primereact/button';
import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from 'primereact/divider';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { ScrollPanel } from 'primereact/scrollpanel';
import EmisorPermiso from './EmisorPermiso';
import { seleccionarEmisor } from '../reducer';
import { ListBox } from 'primereact/listbox';
import { useMountEffect } from 'primereact/hooks';
import { isEmpty } from 'lodash';
import {
    ACTUALIZAR_IMAGEN_KUDE_EMISOR,
    AGREGAR_CERTIFICADO_EMISOR,
    ALL_PERMISOS_DE,
    ALL_PERMISOS_EMISOR,
    ALL_PERMISOS_REPORTES,
    ALL_PERMISOS_USUARIOS,
    CAMBIAR_CLAVE_USUARIO,
    CAMBIAR_ESTADO_USUARIO,
    CREAR_DE,
    CREAR_USUARIO,
    DESCARGAR_KUDE_DE,
    DESCARGAR_XML,
    EDITAR_DE,
    EDITAR_USUARIO,
    ELIMINAR_CERTIFICADO_EMISOR,
    ENVIAR_CORREO_DE,
    EVENTO_CANCELACION_DE,
    EVENTO_CONFORMIDAD_DE,
    EVENTO_DESCONOCIMIENTO_DE,
    EVENTO_DISCONFORMIDAD_DE,
    EVENTO_INUTILIZACION_DE,
    EVENTO_NOMINACION_DE,
    EVENTO_RECEPCION_DE,
    LISTAR_DE,
    LISTAR_EMISOR,
    LISTAR_TIMBRADO,
    LISTAR_USUARIOS,
    MODIFICAR_EMISOR,
    MODIFICAR_TIMBRADO,
    REPORTE_VENTAS,
    VER_DETALLE_DE,
    VER_EVENTOS_CORREOS_DE,
    VISOR_XML
} from '../../../../utilities/permission';
import { useHttpClient } from '../../../../hooks/useHttpClient';
import { Toast } from 'primereact/toast';
import UsuarioPermiso from './UsuarioPermiso';
import DEPermiso from './DEPermiso';
import ReportePermiso from './ReportePermiso';

const AsignarPermiso = ({ onSave }) => {
    const toast = useRef(null);
    const httpClient = useHttpClient();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [issuersList, setIssuersList] = useState([]);

    const {
        usuario,
        emisorSeleccionado,
        cargo,
        allPermisosEmisor,
        listarEmisor,
        modificarEmisor,
        agregarCertificadoEmisor,
        eliminarCertificadoEmisor,
        actualizarImagenKudeEmisor,
        allPermisosUsuario,
        crearUsuario,
        listarUsuarios,
        editarUsuarios,
        cambiarEstadoUsuario,
        cambiarClaveUsuario,
        allPermisosDE,
        listarDE,
        verDetalleDE,
        crearDE,
        editarDE,
        eventoNominacionDE,
        eventoRecepcionDE,
        eventoConformidadDE,
        eventoDisconformidadDE,
        eventoInutilizacionDE,
        eventoDesconocimientoDE,
        eventoCancelacionDE,
        descargarKude,
        descargarXML,
        visorXML,
        allPermisosReportes,
        reporteVentas,
        enviarCorreoDE,
        verEventosCorreoDE,
        listarTimbradoEmisor,
        modificarTimbradoEmisor
    } = useSelector((state) => state.usuario);

    useMountEffect(() => {
        setIsLoading(true);
        httpClient
            .get('admin/emisor/all')
            .then((response) => {
                setIssuersList(response.data);
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
            });
    });

    const actualizarPermisos = () => {
        setIsLoading(true);
        const newPermisos = [];
        if (allPermisosEmisor) {
            newPermisos.push(ALL_PERMISOS_EMISOR);
        }
        if (listarEmisor) {
            newPermisos.push(LISTAR_EMISOR);
        }
        if (modificarEmisor) {
            newPermisos.push(MODIFICAR_EMISOR);
        }
        if (agregarCertificadoEmisor) {
            newPermisos.push(AGREGAR_CERTIFICADO_EMISOR);
        }
        if (eliminarCertificadoEmisor) {
            newPermisos.push(ELIMINAR_CERTIFICADO_EMISOR);
        }
        if (actualizarImagenKudeEmisor) {
            newPermisos.push(ACTUALIZAR_IMAGEN_KUDE_EMISOR);
        }
        if (allPermisosUsuario) {
            newPermisos.push(ALL_PERMISOS_USUARIOS);
        }
        if (crearUsuario) {
            newPermisos.push(CREAR_USUARIO);
        }
        if (listarUsuarios) {
            newPermisos.push(LISTAR_USUARIOS);
        }
        if (editarUsuarios) {
            newPermisos.push(EDITAR_USUARIO);
        }
        if (cambiarEstadoUsuario) {
            newPermisos.push(CAMBIAR_ESTADO_USUARIO);
        }
        if (cambiarClaveUsuario) {
            newPermisos.push(CAMBIAR_CLAVE_USUARIO);
        }
        if (allPermisosDE) {
            newPermisos.push(ALL_PERMISOS_DE);
        }
        if (listarDE) {
            newPermisos.push(LISTAR_DE);
        }
        if (verDetalleDE) {
            newPermisos.push(VER_DETALLE_DE);
        }
        if (crearDE) {
            newPermisos.push(CREAR_DE);
        }
        if (editarDE) {
            newPermisos.push(EDITAR_DE);
        }
        if (eventoNominacionDE) {
            newPermisos.push(EVENTO_NOMINACION_DE);
        }
        if (eventoRecepcionDE) {
            newPermisos.push(EVENTO_RECEPCION_DE);
        }
        if (eventoConformidadDE) {
            newPermisos.push(EVENTO_CONFORMIDAD_DE);
        }
        if (eventoDisconformidadDE) {
            newPermisos.push(EVENTO_DISCONFORMIDAD_DE);
        }
        if (eventoInutilizacionDE) {
            newPermisos.push(EVENTO_INUTILIZACION_DE);
        }
        if (eventoDesconocimientoDE) {
            newPermisos.push(EVENTO_DESCONOCIMIENTO_DE);
        }
        if (eventoCancelacionDE) {
            newPermisos.push(EVENTO_CANCELACION_DE);
        }
        if (descargarKude) {
            newPermisos.push(DESCARGAR_KUDE_DE);
        }
        if (descargarXML) {
            newPermisos.push(DESCARGAR_XML);
        }
        if (visorXML) {
            newPermisos.push(VISOR_XML);
        }
        if (enviarCorreoDE) {
            newPermisos.push(ENVIAR_CORREO_DE);
        }
        if (verEventosCorreoDE) {
            newPermisos.push(VER_EVENTOS_CORREOS_DE);
        }
        if (allPermisosReportes) {
            newPermisos.push(ALL_PERMISOS_REPORTES);
        }
        if (reporteVentas) {
            newPermisos.push(REPORTE_VENTAS);
        }
        if (listarTimbradoEmisor) {
            newPermisos.push(LISTAR_TIMBRADO);
        }
        if (modificarTimbradoEmisor) {
            newPermisos.push(MODIFICAR_TIMBRADO);
        }

        const bodyRequest = {
            usuario: usuario,
            emisor: emisorSeleccionado?.ruc,
            cargo: cargo,
            permisos: newPermisos
        };

        httpClient
            .post('/admin/usuario/permisos', bodyRequest)
            .then(() => {
                onSave();
                setIsLoading(false);
                toast.current.show({ severity: 'success', summary: 'Permisos actualizados', detail: `Usuario ${usuario} actualizado correctamente. `, life: 10000 });
            })
            .catch((error) => {
                setIsLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error actualizar los permisos del usuario.', detail: error.response.data.error, life: 10000 });
            });
    };

    const isSubmitReady = () => {
        return !isEmpty(emisorSeleccionado?.ruc);
    };

    return (
        <div>
            <Toast ref={toast} />
            <center>
                <h6>{`Permisos del usuario: ${usuario}`}</h6>
            </center>
            <Divider />
            <Splitter>
                <SplitterPanel className="flex align-items-start justify-content-center" size={20} minSize={20}>
                    <ListBox
                        filter
                        emptyMessage="Agregue un emisor para continuar"
                        options={issuersList}
                        onChange={(e) => dispatch(seleccionarEmisor({ emisorSeleccionado: e.value }))}
                        value={emisorSeleccionado}
                        optionLabel={'razon_social'}
                        className="w-full md:w-22rem"
                    />
                </SplitterPanel>
                <SplitterPanel className="flex align-items-start justify-content-center" size={80}>
                    <ScrollPanel style={{ width: '100%', height: '100%' }}>
                        <div className="flex flex-column align-items-center" style={{ paddingTop: '8px', width: '100%' }}>
                            <h6 style={{ margin: '0' }}>Permisos relacionados con el emisor</h6>
                            <Divider />
                            <EmisorPermiso />
                        </div>
                        <div className="flex flex-column align-items-center" style={{ paddingTop: '8px', width: '100%' }}>
                            <Divider></Divider>
                            <h6 style={{ margin: '0' }}>Permisos relacionados con el usuario</h6>
                            <Divider></Divider>
                            <UsuarioPermiso />
                        </div>
                        <div className="flex flex-column align-items-center" style={{ paddingTop: '8px', width: '100%' }}>
                            <Divider></Divider>
                            <h6 style={{ margin: '0' }}>Permisos relacionados con los documentos electrónicos</h6>
                            <Divider></Divider>
                            <DEPermiso />
                        </div>
                        <div className="flex flex-column align-items-center" style={{ paddingTop: '8px', width: '100%' }}>
                            <Divider></Divider>
                            <h6 style={{ margin: '0' }}>Permisos relacionados con los reportes</h6>
                            <Divider></Divider>
                            <ReportePermiso />
                        </div>
                    </ScrollPanel>
                </SplitterPanel>
            </Splitter>
            <div className="flex flex-wrap justify-content-end gap-2" style={{ paddingTop: '10px' }}>
                <Button type="submit" className="field col-12 md:col-1" disabled={!isSubmitReady()} loading={isLoading} onClick={actualizarPermisos} label="Guardar" />
            </div>
        </div>
    );
};

export default AsignarPermiso;
